// extracted by mini-css-extract-plugin
export default {"notifications-header-container":"Notifications_notifications-header-container__0rysS","notification-switch-text":"Notifications_notification-switch-text__FhFYt"};